import { jsx as _jsx } from "react/jsx-runtime";
import { UnlockOutlined } from "@ant-design/icons";
import { Tag } from "antd";
import { observer } from "mobx-react";
import { useCallback } from "react";
import { useStores } from "../../store/rootStore.js";
import { __ } from "../../utils/i18n.js";
const PRO_TAG_BACKGROUND_COLOR = "#2db7f5";
const ProTag = observer(({ feature })=>{
    const { optionStore: { others: { isPro, proUrl } } } = useStores();
    const open = useCallback(()=>{
        window.open(`${proUrl}&feature=${feature}`);
    }, []);
    return isPro ? null : /*#__PURE__*/ _jsx(Tag, {
        icon: /*#__PURE__*/ _jsx(UnlockOutlined, {}),
        color: PRO_TAG_BACKGROUND_COLOR,
        style: {
            cursor: "pointer"
        },
        onClick: open,
        children: __("Unlock feature")
    });
});
export { ProTag, PRO_TAG_BACKGROUND_COLOR };
